const model = {
  state: {
    token: null,
    languagesId: 1,
    userProfile: {},
    menu: [],
    client: null, //Client selected
    sucursal: null, //Sucursal selected
    clients: [], //Client of user logged
    sucursales: [], //Sucursale of client selected
    lines: [],
    modalReadIt: false,
    inMaintenance: {},
    recentylLogged: false,
    providers: [], //Providers of user logged
    provider: null, //Provider selected
  },
  reducers: {
    setToken(state, token) {
      return Object.assign({}, { ...state, token: token });
    },
    setModalReadIt(state, value) {
      return Object.assign({}, { ...state, modalReadIt: value });
    },
    setMenu(state, menu) {
      return Object.assign({}, { ...state, menu: menu });
    },
    setLanguage(state, languagesId) {
      return Object.assign({}, { ...state, languagesId: languagesId });
    },
    logOut(state) {
      return { token: null, languagesId: 1, userProfile: {}, menu: [] };
    },
    setUser(state, { token, userProfile, menu }) {
      return Object.assign(
        {},
        { ...state, token: token, userProfile: userProfile, menu: menu }
      );
    },
    //Set all clients of user logged
    setClients(state, clients) {
      return Object.assign({}, { ...state, clients: clients });
    },
    //Set Client and sucursal selected
    setClientAndSucursal(state, client, sucursal) {
      return Object.assign(
        {},
        { ...state, client: client, sucursal: sucursal }
      );
    },
    //Set lines of a client
    setLines(state, lines) {
      return Object.assign({}, { ...state, lines: lines });
    },
    //Set all sucursales for client selected
    setSucursales(state, sucursales) {
      return Object.assign({}, { ...state, sucursales: sucursales });
    },
    // Setting inMaintenance
    setInMaintenance(state, inMaintenance) {
      return Object.assign({}, { ...state, inMaintenance: inMaintenance });
    },
    // Setting recentylyLogged
    setRecentlyLogged(state, value) {
      return Object.assign({}, { ...state, recentylLogged: value });
    },
    //Set all providers of user logged
    setProviders(state, providers) {
      return Object.assign({}, { ...state, providers: providers });
    },
    //Set Client and sucursal selected
    setProvider(state, provider) {
      return Object.assign({}, { ...state, provider: provider });
    },
  },
  effects: {},
};
export default model;
